// extracted by mini-css-extract-plugin
export var disclaimerSection = "DisclaimerSection-module--disclaimerSection--2Gsuy";
export var contact = "DisclaimerSection-module--contact--1lbPF";
export var disclaimerMain = "DisclaimerSection-module--disclaimerMain--36kf6";
export var disclaimer = "DisclaimerSection-module--disclaimer--1LlRz";